export const sectionGroupStyles = {
  marginBottom: '16px',
};

export const sectionHeaderStyles = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '8px 12px',
  borderRadius: '6px',
  backgroundColor: ({ palette }) => palette.background.secondary,
  cursor: 'pointer',
  userSelect: 'none',
  transition: 'background-color 0.15s ease',

  '&:hover': {
    backgroundColor: ({ palette }) => palette.background.hoverDefault,
  },
};

export const sectionHeaderLeftStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  flex: 1,
};

export const sectionTitleStyles = {
  color: 'text.primary',
};

export const sectionMetaStyles = {
  color: 'text.secondary',
  whiteSpace: 'nowrap',
};

const expandIconStyles = {
  color: 'text.secondary',
  transition: 'transform 0.2s ease',
};

export const getExpandIconRotationStyles = isExpanded => ({
  ...expandIconStyles,
  transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
});

export const cardsContainerStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  padding: '12px 0',
};

export const subGroupHeaderStyles = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '6px 12px 6px 12px',
  borderRadius: '4px',
  cursor: 'pointer',
  userSelect: 'none',
  transition: 'background-color 0.15s ease',

  '&:hover': {
    backgroundColor: ({ palette }) => palette.background.secondary,
  },
};

export const subGroupHeaderLeftStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  flex: 1,
};

const subGroupExpandIconStyles = {
  color: 'text.disabled',
  transition: 'transform 0.2s ease',
};

export const getSubGroupExpandIconStyles = isExpanded => ({
  ...subGroupExpandIconStyles,
  transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
});

export const subGroupTitleStyles = {
  color: 'text.secondary',
};

export const subGroupMetaStyles = {
  color: 'text.disabled',
  whiteSpace: 'nowrap',
};

export const subGroupCardsContainerStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',
  paddingLeft: '12px',
};
